export default __webpack_public_path__ + "static/media/logo.200a39f9.png";